export default class RatingSummary extends HTMLElement
{
    constructor()
    {
        super();
        this.stylesheet = this.getAttribute('stylesheet');
        this.ratingCategory = JSON.parse(this.getAttribute('rating-category'));
    }

    connectedCallback()
    {
        const template = document.querySelector('#rating-summary');
        this._shadowRoot = this.attachShadow({mode: 'open'});
        let instance = template.content.cloneNode(true);
        let ratingElement;
        let isPercentageRating = false;
        let ratingTemplate = instance.querySelector('[name="rating-element"]');
        let ratingContainer = instance.querySelector('[name="rating-container"]');
        instance.querySelector('[name="stylesheet"]').href = this.stylesheet;

        if (this._checkElementExists(this.ratingCategory) &&
            this._checkElementExists(this.ratingCategory.name) &&
            (this._checkElementExists(this.ratingCategory.ratings) && this.ratingCategory.ratings.length > 0) ||
            (this._checkElementExists(this.ratingCategory.percentageRatings) && this.ratingCategory.percentageRatings.length > 0)
        ) {
            instance.querySelector('[name="rating-category-title"]').innerHTML = this.ratingCategory.name;
            instance.querySelector('[name="rating-category"]').classList.add('progress-bar-container-' + this.ratingCategory.type);

            let ratings;
            if (this._checkElementExists(this.ratingCategory.percentageRatings) && this.ratingCategory.percentageRatings.length > 0) {
                ratings = this.ratingCategory.percentageRatings;
                isPercentageRating = true;
            } else {
                ratings = this.ratingCategory.ratings;
            }
            ratings.forEach((rateElement, index) =>
            {
                var rateValue = rateElement.rate;
                if(rateValue == 10 && !isPercentageRating){
                    rateValue = parseInt(rateValue);
                }

                ratingElement = ratingTemplate.cloneNode(true);
                ratingElement.querySelector('[name="rating-text"]').innerHTML = rateElement.text;
                ratingElement.querySelector('[name="rate"]').innerHTML = isPercentageRating ? rateElement.rate + "%" : rateValue;
                ratingElement.querySelector('[name="progress-bar-value"]').style.width = (isPercentageRating ? rateElement.rate : (rateElement.rate * 100 / this.ratingCategory.maxValue)) + "%";
                ratingContainer.appendChild(ratingElement)
            });
            instance.querySelector('[name="textual-rating-category"]').style.display = 'none';
        } else if (this._checkElementExists(this.ratingCategory) && this._checkElementExists(this.ratingCategory.textualRatings) && this.ratingCategory.textualRatings.length > 0) {
            instance.querySelector('[name="rating-category-title"]').innerHTML = this.ratingCategory.name;
            ratingTemplate = instance.querySelector('[name="textual-rating-element"]');
            ratingContainer = instance.querySelector('[name="textual-rating-category-container"]');
            this.ratingCategory.textualRatings.forEach((rateElement, index) =>
            {
                var rateValue = rateElement.rate;
                ratingElement = ratingTemplate.cloneNode(true);
                ratingElement.querySelector('[name="category"]').innerHTML = rateElement.text;
                ratingElement.querySelector('[name="category-rate"]').innerHTML = isPercentageRating ? rateElement.rate + "%" : rateValue;
                ratingElement.querySelector('[name="category-type"]').classList.add('ci-' + rateElement.img);
                ratingContainer.appendChild(ratingElement)
            });
            instance.querySelector('[name="rating-category-progress-bar"]').style.display = 'none';
        }
        ratingTemplate.remove();

        this._shadowRoot.appendChild(instance);
    }

    _checkElementExists(element)
    {
        if (typeof element !== 'undefined' && element) {
            return true;
        }
        return false;
    }
}